import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"display":"flex","flex":"1","overflow":"hidden"}
}
const _hoisted_2 = {
  key: 0,
  class: "ef-subscribe__step"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ef-subscribe__stepTitle" }, "Liste des formations disponibles :", -1)
const _hoisted_4 = {
  key: 0,
  class: "ef-subscribe__step"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ef-subscribe__stepTitle" }, "Liste des modules à paramétrer", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "ef-subscribe__modules"
}
const _hoisted_8 = { class: "ef-subscribe__main" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "ef-subscribe__moduleTitle" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-cube" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "right fa-solid fa-circle-check"
}
const _hoisted_13 = {
  key: 1,
  class: "right fa-solid fa-circle-exclamation"
}
const _hoisted_14 = { class: "ef-subscribe__moduleInfos" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-globe" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Module en ligne")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "ef-subscribe__moduleInfosSession"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-clock" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-users" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-calendar" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "ef-subscribe__sessions"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "ef-subscribe__sessionPassed"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-hourglass" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "ef-subscribe__sessionDate" }
const _hoisted_30 = { class: "ef-subscribe__sessionTime" }
const _hoisted_31 = { class: "ef-subscribe__sessionDetails" }
const _hoisted_32 = { class: "ef-subscribe__sessionLocation" }
const _hoisted_33 = { class: "ef-subscribe__sessionDisponibility" }
const _hoisted_34 = {
  key: 1,
  class: "ef-subscribe__sessionOnline"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-globe" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("strong", null, "Ce module se déroule en ligne, quand vous le souhaitez", -1)
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "ef-subscribe__validation" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Inscrire")

import {computed, ComputedRef, ref, watch} from "vue";
import Modale from '@/modales/Modale.vue';
import Table from '@/components/Table.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import {useRouter} from "vue-router";
import {getDuration} from '@/functions/utils.ts';

import {TABLE_ITEMS} from "@/constants";
import {storeTraining} from '@/stores/training';
import {storeSystem} from '@/stores/system';


export default /*#__PURE__*/_defineComponent({
  props: {
  usersToSubscribe: { default: [] },
  open: { type: Boolean, default: false },
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props

const _storeTraining = storeTraining();
const _storeSystem = storeSystem();




const processSubscribe = ref(false);
const subscribe = () => {
  processSubscribe.value = true;
  const modulesSubscriptions: Array<Object> = [];
  modules.value.forEach((module: any) => {
    if (module.session) modulesSubscriptions.push({moduleId: module.id, sessionId: module.session.id});
  });
  _storeTraining.subscribe(training.value.id, props.usersToSubscribe, modulesSubscriptions).then((response) => {
    _storeSystem.addInfoTag({id: '', type: 'success', text: "Demande d'inscription envoyée"});
    processSubscribe.value = false;
    _storeSystem.getSidenavInfos();
    emit('close');
  });
};

const loading = ref(false);
const step = ref(1);
const trainings = ref<Array<any>>([]);
const trainingsLength = ref(0);

const trainingsToDisplay: ComputedRef<Array<Object>> = computed(() => {
  if (trainings.value.length === 0) {
    return [{ id: 1, img: 'empty', fields: [{title: 'title', value: 'value'}, {title: 'title', value: 'value'}], actions: [{ icon: 'fa-solid fa-pen', text: 'Editer', action: 'edit' }] }];
  } else {
    let actions = [
      { icon: 'fa-solid fa-angle-right', text: 'Inscrire', action: 'next' },
      { icon: 'fa-solid fa-eye', text: 'Voir', action: 'view' },
    ];
    let result = trainings.value;
    return result.map((item) => {
      const fields = [
        { title: 'Titre', value: item.title },
        { title: "Heures", value: getDuration(item.eduDuration)  },
      ]
      return { id: item.id, img: item.img ? item.img : 'empty', fields: fields, actions: actions };
    });
  }
});

const isValid: ComputedRef<boolean> = computed(() => {
  if (modules.value) return modules.value.filter((module: any) => module.type === 'online' || module.session && module.session.id !== '').length === modules.value.length;
  else return false;
});

const training = ref<any>();
const modules = ref<any>();
const nextStep = (trainingId: string, newStep: number) => {
  switch (newStep) {
    case 1:
      step.value = 1;
      break;
    case 2:
      loading.value = true;
      step.value = 2;
      _storeTraining.getTraining(trainingId).then((response) => {
        training.value = response.training;
        modules.value = response.modules;
        moduleSelected.value = modules.value[0];
        loading.value = false;
      });
  }
  step.value = newStep;
};

const moduleSelected = ref({ id: '', session: { id: '' }});

const router = useRouter();
const goToTraining = (trainingId: string) => {
  _storeSystem.closeModale();
  router.push(`/trainings/${trainingId}`)
}

const isPassed = (date: any) => {
  console.log(date.setHours(0, 0, 0, 0),  new Date().setHours(0, 0, 0, 0), date.setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0));
  return date.setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
}

watch(() => props.open, (newValue) => {
  if (newValue) {
    step.value = 1;
    loading.value = true;
    _storeTraining.getAllTrainings(0,TABLE_ITEMS*2).then((response) => {
      trainings.value = response;
      trainingsLength.value = response.length;
      loading.value = false;
    });
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modale, {
    class: "ef-subscribe",
    title: "Inscrire un collaborateur à une formation",
    open: __props.open,
    width: "80%",
    height: "90%",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      (processSubscribe.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_Transition, {
              name: "carousel",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (step.value === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _hoisted_3,
                      _createVNode(Table, {
                        items: _unref(trainingsToDisplay),
                        loading: loading.value,
                        onNext: _cache[0] || (_cache[0] = ($event: any) => (nextStep($event, 2))),
                        onView: _cache[1] || (_cache[1] = ($event: any) => (goToTraining($event)))
                      }, null, 8, ["items", "loading"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              name: "carousel",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (step.value === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _hoisted_5,
                      (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "loading"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modules.value, (module) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(['ef-subscribe__module clickable', {'-selected' : moduleSelected.value.id === module.id}]),
                                  onClick: ($event: any) => (moduleSelected.value = module),
                                  key: module.id
                                }, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _hoisted_11,
                                    _createTextVNode(" " + _toDisplayString(module.title) + " ", 1),
                                    (module.type === 'online' || module.session)
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                                      : (_openBlock(), _createElementBlock("i", _hoisted_13))
                                  ]),
                                  _createElementVNode("div", _hoisted_14, [
                                    (module.type === 'online')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
                                      : (!module.session)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Veuillez séléectionner une session"))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createElementVNode("div", null, [
                                              _hoisted_21,
                                              _createTextVNode(_toDisplayString(_unref(getDuration)(module.session.eduduration)), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _hoisted_22,
                                              _createTextVNode(_toDisplayString(module.session.nbSubscriptions) + " / " + _toDisplayString(module.session.seats), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                              _hoisted_23,
                                              _createTextVNode(_toDisplayString(new Date(module.session.startDate).toLocaleString()), 1)
                                            ])
                                          ]))
                                  ])
                                ], 10, _hoisted_9))
                              }), 128))
                            ]),
                            (moduleSelected.value.type !== 'online')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moduleSelected.value.sessions, (session) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(['ef-subscribe__session clickable', {'-selected' : moduleSelected.value.session && moduleSelected.value.session.id === session.id}, {'-passed' : isPassed(new Date(session.startDate))}]),
                                      key: session.id,
                                      onClick: ($event: any) => (moduleSelected.value.session = session)
                                    }, [
                                      (isPassed(new Date(session.startDate)))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_29, _toDisplayString(new Date(session.startDate).toLocaleString().split(" ")[0]), 1),
                                      _createElementVNode("div", _hoisted_30, _toDisplayString(new Date(session.startDate).toLocaleString().split(" ")[1]) + " -> " + _toDisplayString(new Date(session.endDate).toLocaleString().split(" ")[1]), 1),
                                      _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("div", _hoisted_32, _toDisplayString(session.location), 1),
                                        _createElementVNode("div", _hoisted_33, _toDisplayString(session.nbSubscriptions) + " / " + _toDisplayString(session.seats), 1)
                                      ])
                                    ], 10, _hoisted_25))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_37))
                          ])),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(Button, {
                          onClick: subscribe,
                          disabled: !_unref(isValid)
                        }, {
                          default: _withCtx(() => [
                            _hoisted_39
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})